import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {goToPage, reportAnalytics, upgradeProduct} from '../saleBlockSlice';
import FiberUpgrades from '../FiberUpgrades/FiberUpgrades';

const FiberUpgradesPage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_6', eventLabel: eventLabel});
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handleFiberUpgradesPageContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;  
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> איזו מהירות מתאימה לכם? </h1>
    </div>
  );

  const selectedProduct = props.productsInfo.selectedProducts[0];

  let currentPageView = (
    <FiberUpgrades selectedProduct={selectedProduct} products={props.productsInfo.productsForUpgrade} onProductUpgrade={handleOnProductUpgrade} />
  );

  function handleOnProductUpgrade(productData) {
    props.upgradeProduct({productId: productData.productId, isChecked: productData.isChecked});
  }

  function handleFiberUpgradesPageContinue() {

    const eventLabel = props.productsInfo.selectedProducts[0]?.name;
    props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_6', eventLabel: eventLabel});

    if (flowType == 'existsCustomer') {
      props.goToPage({page: 'technicianPage', percent: 36});
    } else {
      props.goToPage({page: 'technicianPage', percent: 50});
    }
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        {currentPageView}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}          
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,    
    productsInfo: state.saleBlock.productsInfo
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  upgradeProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(FiberUpgradesPage);
